import { render } from "./CustomSelectRange.vue?vue&type=template&id=3d4380a0"
import script from "./CustomSelectRange.vue?vue&type=script&lang=js"
export * from "./CustomSelectRange.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__